import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './css/rentol-custom-rtl.css';
import './css/rentol-rtl.css';
import './css/rentol.css';
import './css/style.css';
// import './css/gutenverse-content-44-824245fb7c.css';
// import './css/gutenverse-content-59-824245fb7c.css';
// import './css/gutenverse-content-349-824245fb7c.css';
// import './css/gutenverse-content-353-824245fb7c.css';
// import './css/gutenverse-content-356-824245fb7c.css';
// import './css/gutenverse-content-359-824245fb7c.css';
// import './css/gutenverse-content-362-824245fb7c.css';
// import './css/gutenverse-content-365-824245fb7c.css';
// import './css/gutenverse-content-1150-824245fb7c.css';
// import './css/gutenverse-template-single-824245fb7c.css';
// import './css/index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
